import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.object.values";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "OpSearchTabel",
  props: {
    data: {
      type: Array,
      required: true,
      default: null
    }
  },
  data: function data() {
    return {
      filterText: '',
      isShowDown: false
    };
  },
  watch: {
    // filterText(val) {
    //   this.$refs.tree.filter(val);
    // }
  },
  methods: {
    rowClick: function rowClick(row) {
      var values = Object.values(row);
      this.filterText = values.join("/");
      this.$emit('input', row.id);
    },
    showDown: function showDown() {
      this.isShowDown = !this.isShowDown;
    }
  }
};